function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPigelloLogoNoTextWhiteGraphiteOpacity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    opacity: 0.6,
    viewBox: "0 0 279.0844 279.0844",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 139.5422,
    cy: 139.5422,
    r: 139.5422,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "P"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LINE"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "215.49 111.23 122.752 164.773 122.752 184.16 215.49 130.618 215.49 111.23",
    style: {
      fill: "#202225"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE-2",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.332,198.9274,198.7,174.4661a33.58,33.58,0,0,0,16.79-29.0808l-92.7378,53.5421A33.5794,33.5794,0,0,0,156.332,198.9274Z",
    style: {
      fill: "#202225"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE-3",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.49,96.4627A33.58,33.58,0,0,0,198.7,67.3818L156.332,42.9205a33.58,33.58,0,0,0-33.58,0Z",
    style: {
      fill: "#202225"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE-4",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "109.963 50.304 93.173 59.998 185.911 113.54 202.701 103.847 109.963 50.304",
    style: {
      fill: "#202225"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE-5",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "109.963 252.545 93.173 242.852 93.173 74.766 109.963 84.459 109.963 252.545",
    style: {
      fill: "#202225"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "LINE-6",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.3842,67.3818a33.58,33.58,0,0,0-16.79,29.0809V206.387a33.58,33.58,0,0,0,16.79,29.0809Z",
    style: {
      fill: "#202225"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPigelloLogoNoTextWhiteGraphiteOpacity);
export default __webpack_public_path__ + "static/media/pigello_logo_no_text_white_graphite_opacity.cfde9c19949271fb80e7e17e34796854.svg";
export { ForwardRef as ReactComponent };